exports = module.exports = require("../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".datetimepicker-wrapper {\n  vertical-align: middle;\n  display: inline-block;\n}\n\n.datetimepicker-wrapper > input {\n  margin-bottom: 0 !important;\n  width: 130px;\n}\n\n.datetimepicker-wrapper [ng-model=hours], \n.datetimepicker-wrapper [ng-model=minutes] {\n  width: 46px !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/angular-ui-bootstrap-datetimepicker/datetimepicker.css
// module id = 929
// module chunks = 1